import { AxiosRequestConfig, AxiosResponse } from 'axios'

import apiClient from '@core/api/client'

export const demographicAgeGroupService = {
	/**
	 * Get all demographic age groups
	 */
	getDemographicAgeGroups(config?: AxiosRequestConfig): Promise<AxiosResponse> {
		return apiClient.get('/types/demographicAgeGroups', config)
	},
}

export default demographicAgeGroupService
